// libs/router/useRouterCompat.ts
"use client";

// TODO: THIS IS A TEMPORARY FILE TO HELP WITH THE MIGRATION TO NEXT.JS APP ROUTER.

import {
  useRouter as useNextRouter,
  usePathname,
  useSearchParams
} from "next/navigation";

type QueryValue = string | string[];
type Query = Record<string, QueryValue>;

type LegacyRouter = {
  push: (url: string, as?: string, options?: { scroll?: boolean }) => void;
  replace: (url: string, as?: string, options?: { scroll?: boolean }) => void;
  prefetch: (url: string) => Promise<void>; // no-op in App Router (usa <Link prefetch> in produzione)
  back: () => void;
  forward: () => void;
  reload: () => void; // mappa a router.refresh()
  pathname: string;
  asPath: string;
  query: Query;
  events: {
    on: (..._args: any[]) => void;
    off: (..._args: any[]) => void;
  }; // placeholder: App Router non ha eventi
  isReady: boolean; // true lato client
};

function buildQuery(params: URLSearchParams): Query {
  const q: Query = {};
  // raccoglie chiavi ripetute come array, altrimenti stringa
  params.forEach((value, key) => {
    if (q[key] === undefined) {
      // verifica se la chiave esiste più volte
      const all = params.getAll(key);
      q[key] = all.length > 1 ? all : value;
    } else if (Array.isArray(q[key])) {
      (q[key] as string[]).push(value);
    } else {
      q[key] = [q[key] as string, value];
    }
  });
  return q;
}

export const useRouter = (): LegacyRouter => {
  const router = useNextRouter();
  const pathname = usePathname() || "";
  const searchParams = useSearchParams();

  const search = searchParams?.toString() || "";
  const asPath = search ? `${pathname}?${search}` : pathname;
  const query = buildQuery(searchParams ?? new URLSearchParams());

  return {
    push: (url, _as, options) => router.push(url, { scroll: options?.scroll }),
    replace: (url, _as, options) =>
      router.replace(url, { scroll: options?.scroll }),
    prefetch: async (_url: string) => {
      // Non esiste router.prefetch nell’App Router.
      // Usa <Link prefetch> o lascia che Next gestisca l’autoprefetch.
      return Promise.resolve();
    },
    back: () => router.back(),
    forward: () => {
      if (typeof window !== "undefined") window.history.forward();
    },
    reload: () => router.refresh(),
    pathname,
    asPath,
    query,
    events: {
      on: () => {
        /* no-op */
      },
      off: () => {
        /* no-op */
      }
    },
    isReady: true
  };
};
